import api from '../api';
import type {
  DispatchNowResult,
  ReminderLog,
  ReminderLogFilters,
  ReminderResendResult,
  ReminderSchedule,
  ReminderScheduleCreate,
  ReminderScheduleUpdate,
} from '../../types/compliance';

// NOTE: the shared axios instance (`services/api.ts`) is configured with
// baseURL = config.API_URL, which already includes the `/api/v1` prefix.
// Paths here are relative to that prefix.
const BASE = '/compliance/reminders';

export interface ReminderScheduleListParams {
  alert_type?: string;
  is_active?: boolean;
}

export const remindersService = {
  // --- Schedules ---
  async listSchedules(params?: ReminderScheduleListParams): Promise<ReminderSchedule[]> {
    const { data } = await api.get<ReminderSchedule[]>(`${BASE}/schedules`, { params });
    return data;
  },

  async createSchedule(body: ReminderScheduleCreate): Promise<ReminderSchedule> {
    const { data } = await api.post<ReminderSchedule>(`${BASE}/schedules`, body);
    return data;
  },

  async updateSchedule(id: string, body: ReminderScheduleUpdate): Promise<ReminderSchedule> {
    const { data } = await api.patch<ReminderSchedule>(`${BASE}/schedules/${id}`, body);
    return data;
  },

  async deleteSchedule(id: string): Promise<void> {
    await api.delete(`${BASE}/schedules/${id}`);
  },

  // --- Logs ---
  async listLogs(filters?: ReminderLogFilters): Promise<ReminderLog[]> {
    const { data } = await api.get<ReminderLog[]>(`${BASE}/logs`, { params: filters });
    return data;
  },

  async resend(logId: string): Promise<ReminderResendResult> {
    const { data } = await api.post<ReminderResendResult>(`${BASE}/logs/${logId}/resend`);
    return data;
  },

  // --- Admin ---
  async dispatchNow(): Promise<DispatchNowResult> {
    const { data } = await api.post<DispatchNowResult>(`${BASE}/dispatch-now`);
    return data;
  },
};

export default remindersService;
